"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var conditions = [
    {
        id: 'USED',
        title: 'Не битая',
    },
    {
        id: 'BEATEN',
        title: 'Битая',
    },
];
var getAvailableConditions = function () {
    return conditions;
};
exports.default = getAvailableConditions;
